import dashboards from "./dashboards";
import apps from "./apps";
import pages from "./pages";
import userInterface from "./user-interface";

const navigation = [...dashboards, ...apps, ...pages, ...userInterface];

export default navigation